import React, { useEffect, useState } from "react"

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2147483647,
  pointerEvents: "auto",
  cursor: "pointer",
}

const popupStyle = {
  background: "#FFFFFF",
  borderRadius: 12,
  padding: "40px 50px",
  textAlign: "center",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
  maxWidth: "400px",
  width: "90%",
  pointerEvents: "auto",
}

const iconContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
  position: "relative",
}

const textStyle = {
  color: "#555555",
  fontSize: "18px",
  fontWeight: 500,
  fontFamily: "Arial, Helvetica, sans-serif",
  margin: 0,
  lineHeight: "1.4",
}

export default function OfflineNotice() {
  const [isOffline, setIsOffline] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (typeof window === "undefined") return

    const update = () => {
      const offline = !window.navigator.onLine
      setIsOffline(offline)
    }

    update()
    window.addEventListener("online", update)
    window.addEventListener("offline", update)

    return () => {
      window.removeEventListener("online", update)
      window.removeEventListener("offline", update)
    }
  }, [])

  if (!isClient || !isOffline) return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={overlayStyle}
    >
      <div
        style={popupStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={iconContainerStyle}>
          {/* Combined Icon Container */}
          <div
  style={{
    position: "relative",
    width: "90px",   // reduced container width
    height: "70px",  // reduced container height
  }}
>
  {/* Wi-Fi Signal Icon */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="58"
    fill="currentColor"
    className="bi bi-wifi"
    viewBox="0 0 16 16"
    style={{
      position: "absolute",
      left: 0,
      top: 0,
      color: "#38BDF8",
    }}
  >
    <path d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.44 12.44 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.52.52 0 0 0 .668.05A11.45 11.45 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049" />
    <path d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.46 9.46 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065m-2.183 2.183c.226-.226.185-.605-.1-.75A6.5 6.5 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.5 5.5 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091zM9.06 12.44c.196-.196.198-.52-.04-.66A2 2 0 0 0 8 11.5a2 2 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z" />
  </svg>

  {/* Warning Triangle Icon */}
  <svg
    width="50"
    height="50"
    viewBox="0 0 40 40"
    style={{
      position: "absolute",
      left: "32px",  // moved closer
      top: "16px",   // slightly adjusted
      zIndex: 2,
    }}
  >
    <path
      d="M 20 5 L 35 30 L 5 30 Z"
      fill="#FFFFFF"
      stroke="#F7931E"
      strokeWidth="2.5"
    />
    <path
      d="M 20 12 L 20 22"
      stroke="#F7931E"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="20" cy="26" r="1.5" fill="#F7931E" />
  </svg>
</div>

        </div>
        <p style={textStyle}>No Internet Connection</p>
      </div>
    </div>
  )
}

